<template>
  <transition
    v-if="modalVisible"
    name="modal-transition"
  >
    <div class="modal-mask flex-fJcenter-fAcenter">
      <div class="modal-wrapper flex-fJcenter-fAcenter">
        <div
          :style="modalStyle"
          :class="modalWarning ? 'modal--warning' : ''"
          class="modal flex-col-fJbetween-fAstretch"
        >
          <div class="modal__header flex-fJcenter-fAcenter">
            <span class="modal__title">{{ modalTitle }}</span>
            <span
              class="modal__cross ui-icon ui-icon-closethick"
              @click="closeModal"
            />
          </div>
          <div class="modal__content">
            <component :is="modalContent" />
          </div>
          <div class="modal__footer flex-fJend-fAcenter">
            <button
              class="modal__cancel"
              @click="modalCancelAction()"
            >
              {{ modalCancelTitle }}
            </button>
            <button
              class="modal__validate"
              @click="modalValidateAction()"
            >
              {{ modalValidateTitle }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'modalVisible',
      'modalStyle',
      'modalTitle',
      'modalCancelTitle',
      'modalCancelAction',
      'modalValidateTitle',
      'modalValidateAction',
      'modalContent',
      'modalWarning'
    ])
  },
  methods: {
    ...mapActions(['closeModal'])
  }
}
</script>
<style scoped>

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  width: 100%;
  height: 100%;
}

.modal {
  position: relative;
  min-width: 30%;
  max-height: 80%;
  padding: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal--warning {
  border-color: red;
  transform: translate3d(0, 0, 0);
  animation: shake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  backface-visibility: hidden;
  perspective: 1000px;
}

.modal__header {
  margin-bottom: 20px;
}

.modal__title {
  font-size: 24px;
}

.modal__cross {
  display: block;
  position: absolute;
  top: 16px;
  right: 16px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.modal__content {
  flex: 1;
  max-height: 300px;
  padding: 1rem;
  overflow: auto;
  border-top: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

.modal__footer {
  margin: 20px 0 0;
}

button {
  padding: 2px 12px;
  margin-left: 10px;
  font-size: 18px;
  font-weight: 400;
  border-radius: 0;
  cursor: pointer;
  border: 0.1rem solid transparent;
  background-color: #f18731;
  color: #ffffff;
}
button:hover {
  background-color: #3b3b3b;
  color: #f18731;
}

.modal__cancel {
  background-color: #3b3b3b;
  color: #ffffff;
}
.modal__cancel:hover {
  background-color: #3b3b3b;
  color: #f18731;
}

.modal__validate {
  background-color: #f18731;
  color: #ffffff;
}
.modal__validate:hover {
  background-color: #3b3b3b;
  color: #f18731;
}

.modal-transition-enter {
  opacity: 0;
}

.modal-transition-leave-active {
  opacity: 0;
}

.modal-transition-enter-active .modal {
  animation: bounceInUp 0.5s;
}

.modal-transition-leave-active .modal {
  animation: bounceInUp 0.5s reverse;
}

@keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
